import {ActionType, createAction} from 'typesafe-actions';
import {DataSource} from '../../../../interfaces/DataSource';
import {PrefixDTO} from '../../../../interfaces/PrefixDTO';
import {LayersState} from '../../reducers/mapLayersReducer';
import {MapLayer} from '../../../../interfaces/MapLayer';
import {viewerApplicationTestAction} from '../../../../actions';
import {DataSourceState} from '../../reducers/dataReducer';
import {PrefixFilterOptions} from '../../../../interfaces/PrefixFilterOptions';

export const mapSceneMapLayersActivateMapLayer = createAction(
    'MAP_SCENE_MAP_LAYERS_ACTIVATE_MAP_LAYER',
    (action) => (mapLayer: MapLayer) => action({mapLayer}),
);

export const mapSceneMapLayersActivateDataSource = createAction(
    'MAP_SCENE_MAP_LAYERS_ACTIVATE_DATA_SOURCE',
    (action) => (mapSource: DataSource, mapLayerToActivate: string) => action({mapSource, mapLayerToActivate}),
);

export const mapSceneMapLayersDeactivateMapLayer = createAction(
    'MAP_SCENE_MAP_LAYERS_DEACTIVATE_MAP_LAYER',
    (action) => (mapLayer: MapLayer) => action({mapLayer}),
);

export const mapSceneMapLayersUpdateMapLayerConfiguration = createAction(
    'MAP_SCENE_MAP_LAYERS_UPDATE_MAP_LAYER_CONFIGURATION',
    (action) => (mapLayers: LayersState, dataSources: DataSourceState) => action({mapLayers, dataSources}),
);

export const mapSceneMapLayersUpdatePrefixData = createAction(
    'MAP_SCENE_MAP_LAYERS_UPDATE_PREFIX_DATA',
    (action) => (prefixes: PrefixDTO[]) => action({prefixes}),
);

export const mapSceneMapLayersUpdatePrefixV2Data = createAction(
    'MAP_SCENE_MAP_LAYERS_UPDATE_PREFIX_V2_DATA',
    (action) => (prefixType: keyof PrefixFilterOptions, prefixes: string[]) => action({prefixType, prefixes}),
);

export const mapSceneMapLayersUpdateSourceConfiguration = createAction(
    'MAP_SCENE_MAP_LAYERS_ACTIVATE_DATA_SOURCE',
    (action) => (mapSource: DataSource, mapLayerToActivate: string) => action({mapSource, mapLayerToActivate}),
);

export type MapSceneMapLayersActionTypes =
    | ActionType<typeof mapSceneMapLayersActivateMapLayer>
    | ActionType<typeof mapSceneMapLayersActivateDataSource>
    | ActionType<typeof mapSceneMapLayersDeactivateMapLayer>
    | ActionType<typeof mapSceneMapLayersUpdateMapLayerConfiguration>
    | ActionType<typeof mapSceneMapLayersUpdatePrefixData>
    | ActionType<typeof mapSceneMapLayersUpdatePrefixV2Data>
    | ActionType<typeof viewerApplicationTestAction>;
